import React from 'react';
import styles from './styles.module.css';
const SmallSearch = ({ placeholder }) => {
  return (
    <div className={styles.main}>
      <input type={'text'} placeholder={placeholder || 'Search Hotel Name..'} className={styles.textInput} />
      <button className={styles.button}>Search</button>
    </div>
  );
};
export default SmallSearch;
